// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.irS53{margin-top:16px;display:flex;flex-direction:column;gap:16px}@media(max-width: 560px){.irS53{margin-top:8px;gap:8px}}@media(max-width: 560px){.LO6Ro{gap:16px}}@media(max-width: 560px){.bVswF{display:none}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileMaxWidth": `560px`,
	"tabletMinWidth": `561px`,
	"tabletMaxWidth": `1024px`,
	"desktopMinWidth": `1025px`,
	"smallScreenMaxWidth": `1400px`,
	"largeScreenMinWidth": `1401px`,
	"root": `irS53`,
	"rootProposal": `LO6Ro`,
	"dividerHiddenOnMobile": `bVswF`
};
export default ___CSS_LOADER_EXPORT___;
